<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-09-11 10:33:09
 * @LastEditors: 一诺(丘汉文)
 * @LastEditTime: 2019-12-31 14:43:48
 -->
<template>
  <div class="video-upload" v-loading="loading">
    <div class="video-upload-preview" v-if="value">
      <i @click.stop="handleRemove" class="el-icon-close"></i>
      <img v-if="playImg" :src="playImg" @click="handlePreview" class="video-box">
      <video v-else :src="value" @click="handlePreview" class="video-box" :poster="`${value}?vframe/jpg/offset/1`">
        您的浏览器不支持 video 标签。
      </video>
    </div>
    <el-upload
      v-else
      name="data"
      :class="{ isPreview: value }"
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-progress="handleProgress"
      :show-file-list="false"
      :accept="accept"
      :with-credentials="true"
      drag
    >
     <div class="upload-item">
        <i class="el-icon-plus" v-if="!value"></i>
        <span class="text">上传视频</span>
     </div>
    </el-upload>
    <el-dialog v-drag title=""  :visible.sync="dialogVisible" width="874px" v-if="dialogVisible">
      <video :src="value" class="video-item" controls="controls" :poster="`${value}?vframe/jpg/offset/1`" :autoplay="true"></video>
    </el-dialog>
  </div>
</template>
<script>
import * as filter from '@core/filters'

export default {
  name: 'viedoUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    uploadUrl: {
      type: String,
      default: filter.getUploadHost('/cdnadmin/admin/upload/uploadFile_json')
    },
    accept: {
      type: String,
      default: '.mkv,.mp4'
    },
    size: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    img: {
      type: String,
      default: ''
    }
  },
  computed: {
    sizeMsg() {
      const mb = (this.size / 1024 / 1024).toFixed(2)
      let res
      if (mb < 1) {
        res = `${this.size / 1024}KB`
      } else {
        res = `${mb}MB`
      }
      return res
    }
  },
  data() {
    return {
      loading: false,
      videoSize: {},
      dialogVisible: false,
      playImg: '' // 第一针图片
    }
  },
  mounted() {
    this.playImg = this.img
  },
  methods: {
    // 预览
    handlePreview() {
      this.dialogVisible = true
    },
    handleBeforeUpload(file) {
      const rule = this.uploadRules(file)
      if (rule) {
        // 获取视屏宽高
        const url = URL.createObjectURL(file)
        const video = document.createElement('video')
        video.onloadedmetadata = () => {
          // Revoke when you don't need the url any more to release any reference
          URL.revokeObjectURL(url)
          // 先存起来
          this.videoSize = {
            height: video.videoHeight,
            width: video.videoWidth
          }
        }
        video.src = url
        video.load() // fetches metadata
      }
      return rule
    },
    uploadRules(file) {
      const { size } = file.size
      if (this.size && size > this.size) {
        this.$message.error(`上传文件大小限制最大${this.sizeMsg}`)
        this.loading = false
        return false
      }
      const formatReg = new RegExp(this.accept.replace(/,/g, '|'), 'i')
      if (!formatReg.test(file.name)) {
        this.$message.error('格式不正确,请重新上传')
        return false
      }
      return true
    },
    handleProgress() {
      this.loading = true
    },
    handleSuccess(res, files) {
      this.loading = false
      const file = {
        name: files.name,
        url: files.response.url,
        height: this.videoSize.height,
        width: this.videoSize.width
      }
      this.playImg = `${files.response.url}?vframe/jpg/offset/1`
      this.$emit('input', file.url).$emit('update:fileName', file.name).$emit('change', file)
    },
    handleError(err, file) {
      this.$message.error(`"${file.name}"文件上传失败`)
      this.loading = false
    },
    // 删除文件
    handleRemove() {
      this.$confirm('此操作将删除该视频, 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          this.$emit('input', '').$emit('update:fileName', '').$emit('change', {
            name: '',
            url: ''
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/var';
.video-upload {
  display: inline-block;
  position: relative;
  width: 70px;
  height: 70px;
  &-preview {
    position: relative;
    overflow: hidden;
    width: 70px;
    height: 70px;
    border: 1px dashed #d9d9d9;
    background-color: #fff;
    .video-box {
      width: 70px;
      height: 70px;
    }
    .el-icon-close {
      position: absolute;
      top: -18px;
      right: -18px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      transition: all 0.2s ease 0s;
      &:before {
        z-index: 11;
        position: absolute;
        right: 5px;
        top: 5px;
      }
      &:after {
        border: 18px solid transparent;
        content: '';
        z-index: 10;
        right: 0;
        top: 0;
        position: absolute;
        border-top-color: #999;
        border-right-color: #999;
      }
      &:hover {
        &:after {
          border-top-color: #ff4949;
          border-right-color: #ff4949;
        }
      }
    }
    &:hover {
      .el-icon-close {
        top: 0;
        right: 0;
        display: block;
      }
    }
  }
  .isPreview {
    height: 30px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    opacity: 0;
    .el-upload-dragger {
      height: 30px;
      width: 80px;
      border: 0;
      background: transparent;
      border-radius: 0;
      &:hover {
        border: 0;
      }
    }
  }
  &:hover {
    .isPreview {
      opacity: 1;
    }
  }
  &-tips {
    line-height: 20px;
    color: @color-black-base;
  }

  .video-item{
    width: 850px;
    height: 500px;
  }
  /deep/ .el-dialog__body{
    padding:12px;
  }
  
}
  .upload-item{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .text{
      line-height: 16px;
      font-size: 12px;
      color: #666;
    }
  }
  .el-icon-plus{
    margin-top: 12px;
    font-size: 20px;
    color: #8c939d;
  }
</style>
